import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import Preloader from '../../../../../components/other/Preloader/Preloader';
import { useStyles } from './hooks/useStyles';
import { useGetImportErrors } from './hooks/useGetImportErrors';
import { SHeadTableCell } from '../../../../../components/styledComponents/Tables';

export function ModalErrors({
  id,
  closeModal,
}: {
  id?: number | null;
  closeModal: () => void;
}) {
  const { classes } = useStyles();

  const [showModal, setShowModal] = useState(false);
  const { fetchImportErrors, errors, loadingErrors } = useGetImportErrors();

  useEffect(() => {
    setShowModal(!!id);
    if (id) fetchImportErrors({ id });
  }, [id]);

  if (!id) return null;

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          background: 'transparent',
          boxShadow: 'none',
          width: '100%',
        },
      }}
      open={showModal}
      onClose={closeModal}
      maxWidth={false}
      slotProps={{
        backdrop: {
          style: {
            backdropFilter: 'blur(3px)',
            backgroundColor: 'rgba(0,0,30,0.4)',
          },
        },
      }}
    >
      <DialogContent className={classes.dialogContent}>
        {loadingErrors || !errors ? (
          <Preloader />
        ) : (
          <>
            <Table aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <SHeadTableCell className={classes.rowItems}>Partnumber</SHeadTableCell>
                  <SHeadTableCell className={classes.rowItems}>Error</SHeadTableCell>
                  <SHeadTableCell className={classes.rowItems}>Case</SHeadTableCell>
                  <SHeadTableCell className={classes.rowItems}>StoreStock</SHeadTableCell>
                  <SHeadTableCell className={classes.rowItems}>CustomStock</SHeadTableCell>
                  <SHeadTableCell className={classes.rowItems}>Prices</SHeadTableCell>
                  <SHeadTableCell className={classes.rowItems}>DeliveryTime</SHeadTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {errors?.map((error, index) => (
                  <TableRow key={index}>
                    <TableCell component='th' scope='row' className={classes.rowItems}>
                      {error.partnumber}
                    </TableCell>
                    <TableCell component='th' scope='row' className={classes.rowItems}>
                      {error.error}
                    </TableCell>
                    <TableCell component='th' scope='row' className={classes.rowItems}>
                      {error.case}
                    </TableCell>
                    <TableCell component='th' scope='row' className={classes.rowItems}>
                      {error.storeStock}
                    </TableCell>
                    <TableCell component='th' scope='row' className={classes.rowItems}>
                      {error.customStock}
                    </TableCell>
                    <TableCell component='th' scope='row' className={classes.rowItems}>
                      {error.prices.map((price, index) => (
                        <Typography className={classes.rowItems} component='p' key={index} noWrap>
                          {`${price.amount} шт. - ${price.price} руб.`}
                        </Typography>
                      ))}
                    </TableCell>
                    <TableCell component='th' scope='row' className={classes.rowItems}>
                      {error.deliveryTime}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
